<template>
  <div>
    <v-form v-model="valid" ref="searchForm">
      <v-card dark style="border-radius: 10px">
        <v-layout
          wrap
          style="display: flex; align-items: center; padding: 0px 10px"
        >
          <v-flex xs12 sm10 md11>
            <v-layout wrap row justify-space-between class="pa-3">
              <v-flex xs12 sm4 class="search__input px-2 py-3">
                <v-select
                  label="Order type"
                  v-model="search_config.order_type"
                  item-text="name"
                  item-value="value"
                  :items="order_type"
                  :rules="[rules.required]"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 class="search__input px-2 py-3">
                <v-select
                  v-model="search_config.order_status"
                  item-text="name"
                  item-value="value"
                  :items="order_status"
                  :rules="[rules.required]"
                  label="Status"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 class="search__input px-2 py-3">
                <v-select
                  v-model="paymentFilter"
                  item-text="name"
                  item-value="value"
                  :items="paymentList"
                  label="Payment"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 class="search__input px-2 py-3">
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="-30"
                  lazy
                  transition="scale-transition"
                  offset-y
                  style="width: 100%"
                >
                  <v-text-field
                    label="Start"
                    slot="activator"
                    v-model="search_config.datetime_start"
                    prepend-icon="event"
                    readonly
                    :rules="[rules.required]"
                    hide-details
                  ></v-text-field>
                  <v-date-picker
                    color="#333"
                    no-title
                    v-model="search_config.datetime_start"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm4 class="search__input px-2 py-3">
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="-30"
                  lazy
                  transition="scale-transition"
                  offset-y
                  style="width: 100%"
                >
                  <v-text-field
                    label="End"
                    slot="activator"
                    v-model="search_config.datetime_end"
                    prepend-icon="event"
                    :rules="[rules.required]"
                    readonly
                    hide-details
                  ></v-text-field>
                  <v-date-picker
                    color="#333"
                    no-title
                    v-model="search_config.datetime_end"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm4 class="search__input px-2 py-3">
                <v-autocomplete
                  label="District"
                  v-model="selectedDistict[0]"
                  item-text="district_name_th"
                  item-value="district_id"
                  :items="districtList"
                  :loading="isLoadingDistrict"
                  hide-details
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 md1>
            <div class="search__input px-2">
              <div class="pt-2 text-xs-center search-btn" @click="search()">
                <v-progress-circular
                  indeterminate
                  color="black"
                  v-if="searching"
                ></v-progress-circular>
                <v-icon large color="black" v-else>search</v-icon>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      selectedDistict: [0],
      districtList: [
        {
          district_id: 0,
          district_name_th: "ทุกอำเภอ",
          district_name_en: "All district",
        },
      ],
      isLoadingDistrict: false,
      searching: false,
      valid: true,
      rules: {
        required: (value) => !!value || "Required.",
      },
      order_type: [
        { name: "All type", value: "0" },
        { name: "Food delivery", value: "1" },
        { name: "Messenger", value: "2" },
        { name: "Free delivery", value: "3" },
      ],
      order_status: [
        { name: "All status", value: "0" },
        { name: "Completed", value: "6" },
        { name: "Canceled", value: "7" },
      ],
      menu1: false,
      menu2: false,
      date: new Date().toISOString().substr(0, 10),

      paymentList: [
        { name: "All payment", value: 0 },
        { name: "COD", value: 1 },
        { name: "Credit card", value: 2 },
        { name: "PromptPay", value: 3 },
        { name: "Coin", value: 4 },
      ],
      paymentFilter: 0,
    };
  },
  async created() {
    this.fetchDistrictList();
  },
  computed: {
    ...mapState({
      search_config: (state) => state.fetchReportDashboard.search_config,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      provinceNameEn: (state) => state.backOffice.province,
    }),
  },
  methods: {
    ...mapActions({
      fetchOrderReportAll: "fetchReportDashboard/fetchOrderReport",
      fetchOrderReportByDistrict:
        "fetchReportDashboard/fetchOrderReportByDistrict",
      fetchDistrictCore: "fetchProvinceBack/getDistrictCore",
    }),
    async fetchDistrictList() {
      this.isLoadingDistrict = true;
      let province = this.provinceData.find(
        (val) =>
          val.province_name_en.replace(/ /g, "").toLowerCase() ===
          this.provinceNameEn.toLowerCase()
      );
      let districtByProvince = await this.fetchDistrictCore(
        province.province_id
      );
      this.districtList = [...this.districtList, ...districtByProvince];
      this.isLoadingDistrict = false;
    },
    async search() {
      if (this.searching == false) {
        if (this.$refs.searchForm.validate()) {
          this.searching = true;
          if (this.selectedDistict[0] == 0) {
            await this.fetchOrderReportAll({
              ...this.search_config,
              payment: this.paymentFilter,
            });
          } else {
            let payload = {
              district: this.selectedDistict,
              payment: this.paymentFilter,
            };
            await this.fetchOrderReportByDistrict(payload);
          }
          this.searching = false;
          this.$emit("getBetweenDate", {
            start: this.search_config.datetime_start,
            end: this.search_config.datetime_end,
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
.search-btn {
  cursor: pointer;
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
}

@media screen and (max-width: 662px) {
  .search-btn {
    width: 100%;
  }

  .search__input {
    padding-bottom: 10px;
  }
}
</style>
